/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccrualAdjustmentRow } from '../api-models';
// @ts-ignore
import { AccrualBalanceResponse } from '../api-models';
// @ts-ignore
import { AccrualDetailRow } from '../api-models';
// @ts-ignore
import { AccrualEnumOption } from '../api-models';
// @ts-ignore
import { AccrualPayTypeResponse } from '../api-models';
// @ts-ignore
import { AccrualTab } from '../api-models';
// @ts-ignore
import { AccrualTabSetupResponse } from '../api-models';
// @ts-ignore
import { AddAccrualAdjustmentRequest } from '../api-models';
// @ts-ignore
import { AddAccrualAnnualEntitlementRequest } from '../api-models';
// @ts-ignore
import { AnnualEntitlementResponse } from '../api-models';
// @ts-ignore
import { AuditResponse } from '../api-models';
// @ts-ignore
import { DeleteAccrualRequest } from '../api-models';
// @ts-ignore
import { FormSetupResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { RecalculateAccrualsRequest } from '../api-models';
// @ts-ignore
import { RecalculateAccrualsResponse } from '../api-models';
// @ts-ignore
import { SuccessResponse } from '../api-models';
// @ts-ignore
import { UpdateAccrualAdjustmentRequest } from '../api-models';
// @ts-ignore
import { UpdateAccrualAnnualEntitlementRequest } from '../api-models';
/**
 * AccrualsV2Api - axios parameter creator
 * @export
 */
export const AccrualsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the full set of available accrual tabs. Replaces TaAPI  `GET /api/Accruals/v1/AllTabs`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsAllTabsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/accruals/allTabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the accrual pay types available to the employee via their accrual group.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/AccrualPayTypes`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAccrualPayTypesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAccrualPayTypesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/accrualPayTypes`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes an accrual adjustment. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {DeleteAccrualRequest} [deleteAccrualRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsDelete: async (pkEmployeeId: number, deleteAccrualRequest?: DeleteAccrualRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAdjustmentsDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/adjustments`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccrualRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the adjustment rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Adjustments`. 204 NoContent on empty.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAdjustmentsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/adjustments`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new accrual adjustment. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {AddAccrualAdjustmentRequest} [addAccrualAdjustmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsPost: async (pkEmployeeId: number, addAccrualAdjustmentRequest?: AddAccrualAdjustmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAdjustmentsPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/adjustments`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAccrualAdjustmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing accrual adjustment. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {UpdateAccrualAdjustmentRequest} [updateAccrualAdjustmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsPut: async (pkEmployeeId: number, updateAccrualAdjustmentRequest?: UpdateAccrualAdjustmentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAdjustmentsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/adjustments`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccrualAdjustmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the annual entitlement overrides for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/AnnualEntitlementOverrides`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/annualEntitlementOverrides`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes an annual entitlement override. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {DeleteAccrualRequest} [deleteAccrualRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete: async (pkEmployeeId: number, deleteAccrualRequest?: DeleteAccrualRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/annualEntitlements`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccrualRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds an annual entitlement override. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {AddAccrualAnnualEntitlementRequest} [addAccrualAnnualEntitlementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost: async (pkEmployeeId: number, addAccrualAnnualEntitlementRequest?: AddAccrualAnnualEntitlementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/annualEntitlements`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAccrualAnnualEntitlementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing annual entitlement override. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {UpdateAccrualAnnualEntitlementRequest} [updateAccrualAnnualEntitlementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut: async (pkEmployeeId: number, updateAccrualAnnualEntitlementRequest?: UpdateAccrualAnnualEntitlementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/annualEntitlements`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccrualAnnualEntitlementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns audit history for an accrual record. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Audit/{recordId}?tab=`.
         * @param {number} pkEmployeeId 
         * @param {number} recordId 
         * @param {AccrualTab} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAuditRecordIdGet: async (pkEmployeeId: number, recordId: number, tab?: AccrualTab, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAuditRecordIdGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdAuditRecordIdGet', 'recordId', recordId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/audit/{recordId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the accrual balance summary text for the employee. Replaces TaAPI  `GET /api/Accruals/{employeeId}/balance?fetchFromCache=`.
         * @param {number} pkEmployeeId 
         * @param {boolean} [fetchFromCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdBalanceGet: async (pkEmployeeId: number, fetchFromCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdBalanceGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/balance`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fetchFromCache !== undefined) {
                localVarQueryParameter['fetchFromCache'] = fetchFromCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the Balances-tab rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/BalancesTab`. 204 NoContent on empty.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdBalancesTabGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdBalancesTabGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/balancesTab`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the Details-tab rows for the employee, optionally filtered by pay-type PK.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/DetailsTab?payTypeId=`.
         * @param {number} pkEmployeeId 
         * @param {number} [payTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdDetailsTabGet: async (pkEmployeeId: number, payTypeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdDetailsTabGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/detailsTab`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (payTypeId !== undefined) {
                localVarQueryParameter['payTypeId'] = payTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns dynamic form metadata for the requested tab. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/FormSetup?tab=`.
         * @param {number} pkEmployeeId 
         * @param {AccrualTab} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdFormSetupGet: async (pkEmployeeId: number, tab?: AccrualTab, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdFormSetupGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/formSetup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalculates accruals for the employee from `request.StartDate` forward.  Replaces TaAPI `PUT /api/Accruals/v1/{employeeId}/AllAccruals` — renamed to  `/recompute` on SaaSAPI to match the timecard recompute convention.
         * @param {number} pkEmployeeId 
         * @param {RecalculateAccrualsRequest} [recalculateAccrualsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdRecomputePut: async (pkEmployeeId: number, recalculateAccrualsRequest?: RecalculateAccrualsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdRecomputePut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/recompute`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recalculateAccrualsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the tab-setup envelope used by the FE Accruals page bootstrap. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/TabSetup`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdTabSetupGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2AccrualsPkEmployeeIdTabSetupGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/accruals/{pkEmployeeId}/tabSetup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccrualsV2Api - functional programming interface
 * @export
 */
export const AccrualsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccrualsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns the full set of available accrual tabs. Replaces TaAPI  `GET /api/Accruals/v1/AllTabs`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsAllTabsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualEnumOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsAllTabsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the accrual pay types available to the employee via their accrual group.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/AccrualPayTypes`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualPayTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes an accrual adjustment. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {DeleteAccrualRequest} [deleteAccrualRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAdjustmentsDelete(pkEmployeeId: number, deleteAccrualRequest?: DeleteAccrualRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAdjustmentsDelete(pkEmployeeId, deleteAccrualRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the adjustment rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Adjustments`. 204 NoContent on empty.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAdjustmentsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualAdjustmentRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAdjustmentsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a new accrual adjustment. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {AddAccrualAdjustmentRequest} [addAccrualAdjustmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAdjustmentsPost(pkEmployeeId: number, addAccrualAdjustmentRequest?: AddAccrualAdjustmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAdjustmentsPost(pkEmployeeId, addAccrualAdjustmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing accrual adjustment. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {number} pkEmployeeId 
         * @param {UpdateAccrualAdjustmentRequest} [updateAccrualAdjustmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAdjustmentsPut(pkEmployeeId: number, updateAccrualAdjustmentRequest?: UpdateAccrualAdjustmentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAdjustmentsPut(pkEmployeeId, updateAccrualAdjustmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the annual entitlement overrides for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/AnnualEntitlementOverrides`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnualEntitlementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes an annual entitlement override. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {DeleteAccrualRequest} [deleteAccrualRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(pkEmployeeId: number, deleteAccrualRequest?: DeleteAccrualRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(pkEmployeeId, deleteAccrualRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds an annual entitlement override. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {AddAccrualAnnualEntitlementRequest} [addAccrualAnnualEntitlementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(pkEmployeeId: number, addAccrualAnnualEntitlementRequest?: AddAccrualAnnualEntitlementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(pkEmployeeId, addAccrualAnnualEntitlementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing annual entitlement override. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {number} pkEmployeeId 
         * @param {UpdateAccrualAnnualEntitlementRequest} [updateAccrualAnnualEntitlementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(pkEmployeeId: number, updateAccrualAnnualEntitlementRequest?: UpdateAccrualAnnualEntitlementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(pkEmployeeId, updateAccrualAnnualEntitlementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns audit history for an accrual record. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Audit/{recordId}?tab=`.
         * @param {number} pkEmployeeId 
         * @param {number} recordId 
         * @param {AccrualTab} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdAuditRecordIdGet(pkEmployeeId: number, recordId: number, tab?: AccrualTab, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdAuditRecordIdGet(pkEmployeeId, recordId, tab, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the accrual balance summary text for the employee. Replaces TaAPI  `GET /api/Accruals/{employeeId}/balance?fetchFromCache=`.
         * @param {number} pkEmployeeId 
         * @param {boolean} [fetchFromCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdBalanceGet(pkEmployeeId: number, fetchFromCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdBalanceGet(pkEmployeeId, fetchFromCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the Balances-tab rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/BalancesTab`. 204 NoContent on empty.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdBalancesTabGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualBalanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdBalancesTabGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the Details-tab rows for the employee, optionally filtered by pay-type PK.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/DetailsTab?payTypeId=`.
         * @param {number} pkEmployeeId 
         * @param {number} [payTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdDetailsTabGet(pkEmployeeId: number, payTypeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualDetailRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdDetailsTabGet(pkEmployeeId, payTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns dynamic form metadata for the requested tab. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/FormSetup?tab=`.
         * @param {number} pkEmployeeId 
         * @param {AccrualTab} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdFormSetupGet(pkEmployeeId: number, tab?: AccrualTab, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdFormSetupGet(pkEmployeeId, tab, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Recalculates accruals for the employee from `request.StartDate` forward.  Replaces TaAPI `PUT /api/Accruals/v1/{employeeId}/AllAccruals` — renamed to  `/recompute` on SaaSAPI to match the timecard recompute convention.
         * @param {number} pkEmployeeId 
         * @param {RecalculateAccrualsRequest} [recalculateAccrualsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdRecomputePut(pkEmployeeId: number, recalculateAccrualsRequest?: RecalculateAccrualsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecalculateAccrualsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdRecomputePut(pkEmployeeId, recalculateAccrualsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the tab-setup envelope used by the FE Accruals page bootstrap. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/TabSetup`.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2AccrualsPkEmployeeIdTabSetupGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccrualTabSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2AccrualsPkEmployeeIdTabSetupGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccrualsV2Api - factory interface
 * @export
 */
export const AccrualsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccrualsV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns the full set of available accrual tabs. Replaces TaAPI  `GET /api/Accruals/v1/AllTabs`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsAllTabsGet(options?: AxiosRequestConfig): AxiosPromise<Array<AccrualEnumOption>> {
            return localVarFp.apiV2AccrualsAllTabsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the accrual pay types available to the employee via their accrual group.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/AccrualPayTypes`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualPayTypeResponse>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes an accrual adjustment. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsDelete(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAdjustmentsDelete(requestParameters.pkEmployeeId, requestParameters.deleteAccrualRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the adjustment rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Adjustments`. 204 NoContent on empty.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualAdjustmentRow>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAdjustmentsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a new accrual adjustment. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsPost(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAdjustmentsPost(requestParameters.pkEmployeeId, requestParameters.addAccrualAdjustmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing accrual adjustment. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/Adjustments`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAdjustmentsPut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAdjustmentsPut(requestParameters.pkEmployeeId, requestParameters.updateAccrualAdjustmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the annual entitlement overrides for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/AnnualEntitlementOverrides`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AnnualEntitlementResponse>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes an annual entitlement override. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(requestParameters.pkEmployeeId, requestParameters.deleteAccrualRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds an annual entitlement override. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(requestParameters.pkEmployeeId, requestParameters.addAccrualAnnualEntitlementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing annual entitlement override. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest, options?: AxiosRequestConfig): AxiosPromise<SuccessResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(requestParameters.pkEmployeeId, requestParameters.updateAccrualAnnualEntitlementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns audit history for an accrual record. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Audit/{recordId}?tab=`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdAuditRecordIdGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdAuditRecordIdGet(requestParameters.pkEmployeeId, requestParameters.recordId, requestParameters.tab, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the accrual balance summary text for the employee. Replaces TaAPI  `GET /api/Accruals/{employeeId}/balance?fetchFromCache=`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdBalanceGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV2AccrualsPkEmployeeIdBalanceGet(requestParameters.pkEmployeeId, requestParameters.fetchFromCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the Balances-tab rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/BalancesTab`. 204 NoContent on empty.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdBalancesTabGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualBalanceResponse>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdBalancesTabGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the Details-tab rows for the employee, optionally filtered by pay-type PK.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/DetailsTab?payTypeId=`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdDetailsTabGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualDetailRow>> {
            return localVarFp.apiV2AccrualsPkEmployeeIdDetailsTabGet(requestParameters.pkEmployeeId, requestParameters.payTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns dynamic form metadata for the requested tab. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/FormSetup?tab=`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdFormSetupGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest, options?: AxiosRequestConfig): AxiosPromise<FormSetupResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdFormSetupGet(requestParameters.pkEmployeeId, requestParameters.tab, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalculates accruals for the employee from `request.StartDate` forward.  Replaces TaAPI `PUT /api/Accruals/v1/{employeeId}/AllAccruals` — renamed to  `/recompute` on SaaSAPI to match the timecard recompute convention.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdRecomputePut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest, options?: AxiosRequestConfig): AxiosPromise<RecalculateAccrualsResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdRecomputePut(requestParameters.pkEmployeeId, requestParameters.recalculateAccrualsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the tab-setup envelope used by the FE Accruals page bootstrap. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/TabSetup`.
         * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2AccrualsPkEmployeeIdTabSetupGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest, options?: AxiosRequestConfig): AxiosPromise<AccrualTabSetupResponse> {
            return localVarFp.apiV2AccrualsPkEmployeeIdTabSetupGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAccrualPayTypesGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAdjustmentsDelete operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDelete
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {DeleteAccrualRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDelete
     */
    readonly deleteAccrualRequest?: DeleteAccrualRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAdjustmentsGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAdjustmentsPost operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPost
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {AddAccrualAdjustmentRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPost
     */
    readonly addAccrualAdjustmentRequest?: AddAccrualAdjustmentRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAdjustmentsPut operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPut
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {UpdateAccrualAdjustmentRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPut
     */
    readonly updateAccrualAdjustmentRequest?: UpdateAccrualAdjustmentRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {DeleteAccrualRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete
     */
    readonly deleteAccrualRequest?: DeleteAccrualRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPost
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {AddAccrualAnnualEntitlementRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPost
     */
    readonly addAccrualAnnualEntitlementRequest?: AddAccrualAnnualEntitlementRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPut
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {UpdateAccrualAnnualEntitlementRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPut
     */
    readonly updateAccrualAnnualEntitlementRequest?: UpdateAccrualAnnualEntitlementRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdAuditRecordIdGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGet
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGet
     */
    readonly recordId: number

    /**
     * 
     * @type {AccrualTab}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGet
     */
    readonly tab?: AccrualTab
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdBalanceGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGet
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {boolean}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGet
     */
    readonly fetchFromCache?: boolean
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdBalancesTabGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdDetailsTabGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGet
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGet
     */
    readonly payTypeId?: number
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdFormSetupGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGet
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {AccrualTab}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGet
     */
    readonly tab?: AccrualTab
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdRecomputePut operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePut
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {RecalculateAccrualsRequest}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePut
     */
    readonly recalculateAccrualsRequest?: RecalculateAccrualsRequest
}

/**
 * Request parameters for apiV2AccrualsPkEmployeeIdTabSetupGet operation in AccrualsV2Api.
 * @export
 * @interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest
 */
export interface AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGet
     */
    readonly pkEmployeeId: number
}

/**
 * AccrualsV2Api - object-oriented interface
 * @export
 * @class AccrualsV2Api
 * @extends {BaseAPI}
 */
export class AccrualsV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns the full set of available accrual tabs. Replaces TaAPI  `GET /api/Accruals/v1/AllTabs`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsAllTabsGet(options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsAllTabsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the accrual pay types available to the employee via their accrual group.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/AccrualPayTypes`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAccrualPayTypesGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAccrualPayTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes an accrual adjustment. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/Adjustments`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAdjustmentsDelete(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsDeleteRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAdjustmentsDelete(requestParameters.pkEmployeeId, requestParameters.deleteAccrualRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the adjustment rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Adjustments`. 204 NoContent on empty.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAdjustmentsGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAdjustmentsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a new accrual adjustment. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/Adjustments`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAdjustmentsPost(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPostRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAdjustmentsPost(requestParameters.pkEmployeeId, requestParameters.addAccrualAdjustmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing accrual adjustment. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/Adjustments`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAdjustmentsPut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAdjustmentsPutRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAdjustmentsPut(requestParameters.pkEmployeeId, requestParameters.updateAccrualAdjustmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the annual entitlement overrides for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/AnnualEntitlementOverrides`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAnnualEntitlementOverridesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes an annual entitlement override. Replaces TaAPI  `DELETE /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsDeleteRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAnnualEntitlementsDelete(requestParameters.pkEmployeeId, requestParameters.deleteAccrualRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds an annual entitlement override. Replaces TaAPI  `POST /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPostRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAnnualEntitlementsPost(requestParameters.pkEmployeeId, requestParameters.addAccrualAnnualEntitlementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing annual entitlement override. Replaces TaAPI  `PUT /api/Accruals/v1/{employeeId}/AnnualEntitlements`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAnnualEntitlementsPutRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAnnualEntitlementsPut(requestParameters.pkEmployeeId, requestParameters.updateAccrualAnnualEntitlementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns audit history for an accrual record. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/Audit/{recordId}?tab=`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdAuditRecordIdGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdAuditRecordIdGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdAuditRecordIdGet(requestParameters.pkEmployeeId, requestParameters.recordId, requestParameters.tab, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the accrual balance summary text for the employee. Replaces TaAPI  `GET /api/Accruals/{employeeId}/balance?fetchFromCache=`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdBalanceGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalanceGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdBalanceGet(requestParameters.pkEmployeeId, requestParameters.fetchFromCache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the Balances-tab rows for the employee. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/BalancesTab`. 204 NoContent on empty.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdBalancesTabGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdBalancesTabGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdBalancesTabGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the Details-tab rows for the employee, optionally filtered by pay-type PK.  Replaces TaAPI `GET /api/Accruals/v1/{employeeId}/DetailsTab?payTypeId=`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdDetailsTabGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdDetailsTabGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdDetailsTabGet(requestParameters.pkEmployeeId, requestParameters.payTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns dynamic form metadata for the requested tab. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/FormSetup?tab=`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdFormSetupGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdFormSetupGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdFormSetupGet(requestParameters.pkEmployeeId, requestParameters.tab, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalculates accruals for the employee from `request.StartDate` forward.  Replaces TaAPI `PUT /api/Accruals/v1/{employeeId}/AllAccruals` — renamed to  `/recompute` on SaaSAPI to match the timecard recompute convention.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdRecomputePut(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdRecomputePutRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdRecomputePut(requestParameters.pkEmployeeId, requestParameters.recalculateAccrualsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the tab-setup envelope used by the FE Accruals page bootstrap. Replaces TaAPI  `GET /api/Accruals/v1/{employeeId}/TabSetup`.
     * @param {AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccrualsV2Api
     */
    public apiV2AccrualsPkEmployeeIdTabSetupGet(requestParameters: AccrualsV2ApiApiV2AccrualsPkEmployeeIdTabSetupGetRequest, options?: AxiosRequestConfig) {
        return AccrualsV2ApiFp(this.configuration).apiV2AccrualsPkEmployeeIdTabSetupGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
